import { render } from "./TasksSummaryComponent.vue?vue&type=template&id=b0aa75ee"
import script from "./TasksSummaryComponent.vue?vue&type=script&lang=js"
export * from "./TasksSummaryComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__